// extracted by mini-css-extract-plugin
export default {"container":"kP-z","modal":"lP-z","dimensions":"mP-z","brandName":"nP-z","productName":"oP-z","recipientEmail":"pP-z","recommendedFit":"qP-z","hiddenField":"rP-z"};